<template>
    <div>
        <div>
            <progress-header />
        </div>

        <div class="container mt-4">
            <div class="card shadow-sm mt-4 px-4 py-3">
                <h4 class="text-blue-600 font-weight-bold">
                    {{ $t('coaches.contact_data.header') }}
                </h4>

                <form class="container align-items-center bg-white p-2 mt-2 mx-auto"
                    @submit.prevent="handleSubmit"
                >
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="name">{{ $t('coaches.contact_data.name') }}</label>

                            <input id="name" type="text" name="name" class="form-control" required v-model="contact.name">
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="company-name">{{ $t('coaches.contact_data.company_name') }}</label>
                            <input id="company-name" type="text" name="company-name" class="form-control" v-model="contact.company_name">
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="address">{{ $t('coaches.contact_data.address') }}</label>
                            <input id="address" type="text" name="address" class="form-control" v-model="contact.address">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="post_code">{{ $t('coaches.contact_data.post_code') }}</label>
                            <input id="post_code" type="text" name="" class="form-control" v-model="contact.post_code">
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="city">{{ $t('coaches.contact_data.city') }}</label>
                            <input id="city" type="text" name="" class="form-control" v-model="contact.city">
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="country">{{ $t('coaches.contact_data.country') }}</label>
                            <input id="country" type="text" name="" class="form-control" v-model="contact.country">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="tax_number">{{ $t('coaches.contact_data.tax_number') }}</label>
                            <input id="tax_number" type="text" name="tax-number" class="form-control" v-model="contact.tax_number">
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="phone">{{ $t('coaches.contact_data.phone_number') }}</label>

                            <phone-input
                                id="phone"
                                input-class="form-control"
                                :required="true"
                                :value="contact.phone"
                                @input="onPhoneInput($event)"
                            />
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 form-group">
                            <label for="email">{{ $t('coaches.contact_data.email') }}</label>
                            <input id="email" type="email" name="email" class="form-control" required v-model="contact.email">
                        </div>
                    </div>

                    <template v-if="!isLoggedIn">
                        <div class="row">
                            <div class="col-12">
                                <label for="create-account" class="text-muted text-sm">{{ $t('coaches.contact_data.create_account') }}</label>
                                <input id="create-account" type="checkbox" name="create-account" v-model="createAccount">
                            </div>
                        </div>
                    </template>

                    <template v-if="createAccount">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="password">{{ $t('auth.password') }}</label>
                                <input id="password" type="password" name="password" class="form-control" v-model="contact.password">
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="password_confirmation">{{ $t('auth.confirm_password') }}</label>
                                <input id="password_confirmation" type="password" name="password_confirmation" class="form-control" v-model="contact.password_confirmation">
                            </div>
                        </div>
                    </template>

                    <div class="w-100 mt-2">
                        <button type="submit" class="btn btn-primary w-100">
                            {{ $t('components.coach_search_form.submit') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import ProgressHeader from './components/ProgressHeader';
    import {mapGetters} from 'vuex';
    import toastr from 'toastr';
    import {validateEmail} from '@utilities/validation';

    export default {
        components: {
            ProgressHeader,
        },
        data() {
            return {
                contact: {
                    name: '',
                    company_name: '',
                    address: '',
                    tax_number: '',
                    phone: '',
                    email: '',
                    post_code: '',
                    city: '',
                    country: '',
                },
                createAccount: false,
                query: this.$route.query,
            };
        },
        computed: {
            ...mapGetters({
                userName: 'user/getName',
                userCompanyName: 'user/getCompanyName',
                userAddress: 'user/getAddress',
                userTaxNumber: 'user/getTaxNumber',
                userPhone: 'user/getPhone',
                userEmail: 'user/getEmail',
                userPostCode: 'user/getPostCode',
                userCity: 'user/getCity',
                userCountry: 'user/getCountry',
                isLoggedIn: 'user/isLoggedIn',
                contactData: 'coachesOrder/getContact',
            }),
        },

        created() {
            this.contact = this.contactData;

            if (!this.contact.name) {
                this.contact.name = this.userName;
            }

            if (!this.contact.company_name) {
                this.contact.company_name = this.userCompanyName;
            }

            if (!this.contact.address) {
                this.contact.address = this.userAddress;
            }

            if (!this.contact.tax_number) {
                this.contact.tax_number = this.userTaxNumber;
            }

            if (!this.contact.phone) {
                this.contact.phone = this.userPhone;
            }

            if (!this.contact.email) {
                this.contact.email = this.userEmail;
            }

            if (!this.contact.post_code) {
                this.contact.post_code = this.userPostCode;
            }

            if (!this.contact.city) {
                this.contact.city = this.userCity;
            }

            if (!this.contact.country) {
                this.contact.country = this.userCountry;
            }
        },
        methods: {
            onPhoneInput(value) {
                this.contact.phone = value;
            },

            validatePhone() {
                let valid = true;

                if (this.contact.phone && this.contact.phone.length < 11) {
                    toastr.error(this.$t('airport_transfers.pages.phone_length_error'));
                    valid = false;
                }

                if (this.contact.phone[0] !== '+') {
                    toastr.error(this.$t('phone_has_to_start_with_plus'));
                    valid = false;
                }

                return valid;
            },

            handleSubmit(){
                if(!validateEmail(this.contact.email)) {
                    toastr.error(this.$t('coaches.contact_data.email_invalid'));
                } else if (this.validatePhone()) {
                    this.$store.dispatch('coachesOrder/setContact', this.contact)
                        .then(() => {
                            this.$store.dispatch('coachesOrder/setIsContactComplete', true);
                            this.$router.push({name: 'coaches.summary'});
                        });
                }
            },
        },
    };
</script>
